import { openDialog, openSnackbar } from '../store/actions/page.action';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IReducers } from 'app/store/reducers';
import { logoutSuccess } from '../store/actions/user.action';
import { ButtonDisablerService } from '../store/services/button-disabler.service';

@Injectable()
export class ApiResponseInterceptor implements HttpInterceptor {
  constructor(
    private readonly store: Store<IReducers>,
    private readonly buttonDisabler: ButtonDisablerService,
  ) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          this.buttonDisabler.disableActive();

          if (
            Object.keys(event.body).length > 0 &&
            event.body.hasOwnProperty('data')
          ) {
            const newData = {
              body: event.body.data,
            };

            if (!event.body.data.extra_data && !Array.isArray(newData.body)) {
              newData.body = {
                ...newData.body,
                extra_data: event.body.extra_data,
              };
            }

            return event.clone(newData);
          }
        }


        return event;
      }),
      catchError(event => {
        if (event instanceof HttpErrorResponse) {
          this.buttonDisabler.disableActive();
          if (event.error instanceof Blob && event.error.type === 'application/json') {
            // https://github.com/angular/angular/issues/19888
            // When request of type Blob, the error is also in Blob instead of object of the json data
            return new Promise<any>((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = (e: Event) => {
                try {
                  const errmsg = JSON.parse((<any>e.target).result);
                  reject(new HttpErrorResponse({
                    error: errmsg,
                    headers: event.headers,
                    status: event.status,
                    statusText: event.statusText,
                    url: event.url || undefined,
                  }));
                } catch (e) {
                  reject(event);
                }
              };
              reader.onerror = (e) => {
                reject(event);
              };
              reader.readAsText(event.error);
            });
          }
          if (event.status === 500) {
            this.store.dispatch(
              openDialog({
                dialogData: {
                  title: 'Error During operation',
                  content: 'Something went wrong. Please, try again later!',
                  canClose: true,
                },
              }),
            );
          } else if (event.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('oldTokens');
            this.store.dispatch(logoutSuccess());
            this.store.dispatch(
              openSnackbar({
                snackbarData: {
                  data: {
                    message: 'Your session has expired. Please, login again!',
                    type: 'error',
                  },
                },
              }),
            );
          }
        }

        return throwError(event);
      }),
    );
  }
}
